/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Health_LabelInputs */

const en_us2_native_release_health_label = /** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save workouts to Health Connect`)
};

const pt_br2_native_release_health_label = /** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar treinos no Health Connect`)
};

const pt_pt2_native_release_health_label = /** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar treinos no Health Connect`)
};

/** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */
const es_419_native_release_health_label = en_us2_native_release_health_label;

/** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */
const fr_fr2_native_release_health_label = en_us2_native_release_health_label;

/** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */
const de_de2_native_release_health_label = en_us2_native_release_health_label;

/** @type {(inputs: Native_Release_Health_LabelInputs) => LocalizedString} */
const it_it2_native_release_health_label = en_us2_native_release_health_label;

/**
* | output |
* | --- |
* | "Save workouts to Health Connect" |
*
* @param {Native_Release_Health_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_health_label = /** @type {((inputs?: Native_Release_Health_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Health_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_health_label(inputs)
	if (locale === "es-419") return es_419_native_release_health_label(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_health_label(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_health_label(inputs)
	if (locale === "de-DE") return de_de2_native_release_health_label(inputs)
	if (locale === "it-IT") return it_it2_native_release_health_label(inputs)
	return en_us2_native_release_health_label(inputs)
});
export { native_release_health_label as "native-release.health_label" }